import {
  HHButton,
  HHStack,
  HHTextField,
} from '@hinge-health/react-component-library';
import { isNoteValid, tooLong } from './panel-validation';

interface PanelLayoutProps {
  selectedGrid: React.ReactNode;
  alert: React.ReactNode;
  additionalInputs?: React.ReactNode;
  note?: string;
  setNote?: (note: string) => void;
  setIsOpen: (isOpen: boolean) => void;
  isSubmitting: boolean;
  isInvalid: boolean;
  actionLabel: string;
  handleSubmit: () => void;
}

export const PanelLayout = ({
  selectedGrid,
  alert,
  additionalInputs,
  note,
  setNote,
  setIsOpen,
  isSubmitting,
  isInvalid,
  actionLabel,
  handleSubmit,
}: PanelLayoutProps): JSX.Element => (
  <HHStack direction="column" sx={{ height: '100%' }}>
    <HHStack sx={{ flex: 1 }}>{selectedGrid}</HHStack>
    <HHStack
      spacing={6}
      padding={6}
      direction="column"
      borderTop="1px solid rgba(0,0,0, 0.12)"
      sx={{ flexShrink: 0 }}
    >
      {alert}
      {additionalInputs}
      {note !== undefined && setNote && (
        <HHTextField
          multiline
          label="Why are these changes being made?"
          hhVariant="variant-bypass"
          variant="outlined"
          value={note}
          onChange={(e): void => setNote(e.target.value)}
          fullWidth
          rows={5}
          helperText={
            isNoteValid(note) ? '' : 'Note must be between 5 and 500 characters'
          }
          error={tooLong(note)}
          inputProps={{ role: 'textbox', name: 'note' }}
        />
      )}
      <HHStack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="flex-end"
      >
        <HHButton
          variant="outlined"
          color="primary"
          hhVariant="outlined"
          onClick={(): void => setIsOpen(false)}
        >
          Cancel
        </HHButton>
        <HHButton
          variant="contained"
          color="primary"
          hhVariant="contained"
          onClick={handleSubmit}
          disabled={isSubmitting || isInvalid}
        >
          {actionLabel}
        </HHButton>
      </HHStack>
    </HHStack>
  </HHStack>
);
